import React from 'react';
import captureEvents from '../../analytics-functions';

import {
  addDisabilities,
  claimType,
  newDisabilityFollowUp,
  ratedDisabilities,
} from '..';

import {
  capitalizeEachWord,
  claimingNew,
  DISABILITY_SHARED_CONFIG,
  hasRatedDisabilities,
  isDisabilityPtsd,
} from '../../utils';

import { NULL_CONDITION_STRING } from '../../constants';

import { disabilitiesOrientation } from '../../content/disabilitiesOrientation';

export const disabilityBenefitsWorkflow = {
  claimType: {
    title: 'Your claim type',
    path: 'claim-type',
    depends: formData => hasRatedDisabilities(formData),
    uiSchema: claimType.uiSchema,
    schema: claimType.schema,
    onContinue: captureEvents.claimType,
  },
  disabilitiesOrientation: {
    title: '',
    path: DISABILITY_SHARED_CONFIG.orientation.path,
    depends: formData => DISABILITY_SHARED_CONFIG.orientation.depends(formData),
    uiSchema: { 'ui:description': disabilitiesOrientation },
    schema: { type: 'object', properties: {} },
  },
  ratedDisabilities: {
    title: 'Your rated disabilities',
    path: DISABILITY_SHARED_CONFIG.ratedDisabilities.path,
    depends: formData =>
      DISABILITY_SHARED_CONFIG.ratedDisabilities.depends(formData),
    uiSchema: ratedDisabilities.uiSchema,
    schema: ratedDisabilities.schema,
  },
  addDisabilities: {
    title: 'New conditions you want to claim',
    path: DISABILITY_SHARED_CONFIG.addDisabilities.path,
    depends: formData =>
      DISABILITY_SHARED_CONFIG.addDisabilities.depends(formData),
    uiSchema: addDisabilities.uiSchema,
    schema: addDisabilities.schema,
    updateFormData: addDisabilities.updateFormData,
    appStateSelector: state => ({
      // needed for validateDisabilityName to work properly on the review
      // & submit page. Validation functions are provided the pageData and
      // not the formData on the review & submit page. For more details
      // see https://dsva.slack.com/archives/CBU0KDSB1/p1614182869206900
      newDisabilities: state.form?.data?.newDisabilities || [],
    }),
  },
  followUpDesc: {
    title: 'Add details about your conditions',
    depends: formData => claimingNew(formData),
    path: 'new-disabilities/follow-up',
    uiSchema: {
      'ui:title': (
        <h3 className="vads-u-margin-top--0">
          Add details about your conditions
        </h3>
      ),
      'ui:description':
        'Now we’re going to ask you some follow-up questions about each of your conditions. We’ll go through them one by one.',
    },
    schema: { type: 'object', properties: {} },
  },
  newDisabilityFollowUp: {
    title: formData => (
      <h3 className="vads-u-margin-top--0">
        {typeof formData.condition === 'string'
          ? capitalizeEachWord(formData.condition)
          : NULL_CONDITION_STRING}
      </h3>
    ),
    depends: claimingNew,
    path: 'new-disabilities/follow-up/:index',
    showPagePerItem: true,
    itemFilter: (item, formData) => {
      if (formData?.syncModern0781Flow === true) {
        return !!item.condition;
      }
      return !isDisabilityPtsd(item.condition);
    },
    arrayPath: 'newDisabilities',
    uiSchema: newDisabilityFollowUp.uiSchema,
    schema: newDisabilityFollowUp.schema,
  },
};
